import { useState } from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';

// import Permalink from "./Permalink";
import Edit from "./Edit";
import Delete from "./Delete";

import "./css/menu-button-controller.css";

const MenuButtonController = ({ data, isUserAuthenticated }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    // const [openPermalink, setPermalink] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    // const handlePermalink = () => {
    //     handleClose();
    //     // setPermalink(true);

    //     let permalink;

    //     if (contentOf === "doubt") {
    //         permalink = `http://localhost:3000/doubt/${doubtId}`;
    //     }
    //     else if (contentOf === "answer") {
    //         permalink = `http://localhost:3000/doubt/${doubtId}#${answerId}`;
    //     }

    //     console.log(permalink);
    // }

    const handleEdit = () => {
        handleClose();
        setOpenEdit(true);
    }

    const handleDelete = () => {
        handleClose();
        setOpenDelete(true);
    }

    if (isUserAuthenticated) {
        return (
            <div className="menu-button-controller">
                <IconButton
                    id="long-button"
                    aria-label="more"
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    style={{ color: "#000" }}
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>

                <Menu
                    id="long-menu"
                    MenuListProps={{ "aria-labelledby": "long-button" }}
                    PaperProps={{
                        style: {
                            width: "18ch",
                            borderRadius: "10px",
                            boxShadow: "0 0 40px #ccc"
                        }
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {/* <MenuItem onClick={handlePermalink}>
                    <ListItemIcon>
                        <LinkIcon />
                    </ListItemIcon>
                    Permalink
                </MenuItem> */}

                    <MenuItem onClick={handleEdit}>
                        <ListItemIcon>
                            <EditIcon />
                        </ListItemIcon>
                        Edit
                    </MenuItem>

                    <MenuItem onClick={handleDelete}>
                        <ListItemIcon>
                            <DeleteIcon />
                        </ListItemIcon>
                        Delete
                    </MenuItem>
                </Menu>

                {/* <Permalink
                openPermalink={openPermalink}
                setPermalink={setPermalink}
            /> */}
                <Edit
                    openEdit={openEdit}
                    setOpenEdit={setOpenEdit}
                    data={data}
                />
                <Delete
                    openDelete={openDelete}
                    setOpenDelete={setOpenDelete}
                    data={data}
                />
            </div>
        );
    }
}

export default MenuButtonController;